import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient';

interface Organization {
  id: string;
  email: string;
  name: string;
  status: string;
  user_id: string;
}

const useNotVerifiedUsers = () => {
  return useQuery({
    queryKey: ['organizations', 'not-verified'],
    queryFn: async () => {
      const { data, error } = await supabaseClient
        .from('organizations')
        .select('*')
        .eq('status', 'Pending');

      if (error) throw error;
      return data as Organization[];
    },
  });
};

export default useNotVerifiedUsers;
